export default "__VITE_ASSET__B$sJNKqE__"